// extracted by mini-css-extract-plugin
export default {"coinWrapper":"points-wrapper_coinWrapper__bCWOR","anim":"points-wrapper_anim__1lR+I"};